/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import { ReduxReducer } from '@reducers/types';
import * as actionTypes from '../constants/action-types';
import { SurveyActionData } from '@g17eco/types/surveyAction';

interface UnloadedSurveyReduxReducer extends ReduxReducer<object> {
  loaded: false;
  surveyId?: string;
}

interface LoadedSurveyReduxReducer extends ReduxReducer<SurveyActionData> {
  loaded: true;
  surveyId?: string;
}

export type SurveyState = UnloadedSurveyReduxReducer | LoadedSurveyReduxReducer;

const survey = (
  state: SurveyState = {
    data: {},
    loaded: false,
    errored: false,
    errorMessage: '',
    surveyId: undefined,
  },
  action: AnyAction

): SurveyState => {

  const lastUpdated = Date.now();
  switch (action.type) {

    case actionTypes.LOADING_SURVEY_ACTIONS:
      return { ...state, data: {}, surveyId: action.surveyId, loaded: false, errored: false, lastUpdated };
    case actionTypes.ERROR_SURVEY_ACTIONS:
      return {
        // Retain surveyId to prevent infinite loading in useEffect on error
        surveyId: action.surveyId || state.surveyId,
        data: {},
        loaded: false,
        errored: true,
        lastUpdated,
        errorMessage: action.errorMessage
      };
    case actionTypes.LOADED_SURVEY_ACTIONS:
      return { ...state, data: action.data, loaded: true, errored: false, lastUpdated };
    case actionTypes.UNLOAD_SURVEY_ACTIONS:
      return { ...state, surveyId: undefined, data: {}, loaded: false, errored: false, lastUpdated };
    default:
      return state;

  }

};

export default survey;
